export const DEFAULT_ORGANIZATIONAL_UNIT_ID = '00000000-0000-0000-0000-000000000000';
